import { Observable, BehaviorSubject, Subscription, of } from 'rxjs';
import { filter } from 'rxjs/operators';

import { OutgoingConversationState, IOutgoingConversation, ISkypeMePerson, ISkypePerson } from '../../abstractions';

import { CC4AllAppService } from './services/cc4all-app.service';

export class CC4AllOutboundConversation implements IOutgoingConversation {
  private _state = new BehaviorSubject<OutgoingConversationState>('Created');
  private _selfParticipant = new BehaviorSubject<ISkypeMePerson>(null);
  private _participants = new BehaviorSubject<Array<ISkypePerson>>([]);
  private subscription: Subscription;

  private _isPaused = new BehaviorSubject<boolean>(false);

  public get state$(): Observable<OutgoingConversationState> {
    return this._state.asObservable();
  }
  public get selfParticipant$(): Observable<ISkypeMePerson> {
    return of(null);
  }
  public get participants$(): Observable<ISkypePerson[]> {
    return of([
      {
        id: this.sip,
        displayName$: of(this.sip.replace('sip:', '').replace('tel:', '')),
        avatarUrl$: null,
        status$: null,
        activity$: null,

        dispose: () => {},
      },
    ]);
  }

  constructor(
    public conversationKey: string,
    public sessionId: string,
    private _agentSip: string,
    public sip: string,
    private cc4all: CC4AllAppService,
  ) {
    this.subscription = cc4all.socket.callSessions$.pipe(filter((x) => x.SessionId === this.sessionId)).subscribe((res) => {
      console.log('outgoing call', res);
      switch (res.ConferenceActionAsString) {
        case 'WarmInviteSent':
          this._state.next('Connecting');
          break;

        case 'WarmInviteAccepted':
          this._state.next('Connected');
          break;

        case 'WarmAccepted':
          this._state.next('Connected');
          break;

        case 'WarmInviteRejected':
          this._state.next('Disconnected');
          this.subscription.unsubscribe();
          break;

        case 'WarmCanceled':
          this._state.next('Disconnected');
          this.subscription.unsubscribe();
          break;

        case 'OnHold':
          this._isPaused.next(true);
          break;

        case 'Resumed':
          this._isPaused.next(false);
          break;

        default:
          break;
      }
    });
  }

  public leave(): Observable<boolean> {
    return this.cc4all.finishCall(this.conversationKey, this.sessionId);
  }

  pause(): Observable<boolean> {
    return this.handlePause(true);
  }
  resume(): Observable<boolean> {
    return this.handlePause(false);
  }

  private handlePause(pause: boolean): Observable<boolean> {
    if (pause) {
      return this.cc4all.pauseCall(this.conversationKey, this.sessionId);
    }

    return this.cc4all.resumeCall(this.conversationKey, this.sessionId);
  }
}
